<template>
    <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isAuctionManager()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Auction Lots</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
                            </ol>
                        </div>
                    </div>
                </div><!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br>
                <div class="row">
                    <div class="col-md-3">
                        <button class="btn btn-info" style="width: 100%;" @click="addDialog">Add Lot to Auction</button>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="card card-primary card-outline overflow-auto">
                            <div class="card-body">
                                <table class="table table-striped">
                                    <thead style="position: sticky;top: 0">
                                    <tr>
                                        <th scope="col" class="t-header">Lot Name</th>
                                        <th scope="col" class="t-header">Quote Price</th>
                                        <th scope="col" class="t-header">Control Price</th>
                                        <th scope="col" class="t-header">Highest Bid</th>
                                        <th scope="col" class="t-header">Status</th>
                                        <th scope="col" class="t-header">Manage</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(g, index) in auction_lots">
                                        <th scope="row" >{{g.lot_name}}</th>
                                        <td>{{g.quote_price}}</td>
                                        <td>{{g.control_price}}</td>
                                        <td>{{g.highest_bid_price}}</td>
                                        <td v-if="g.status == 'added'"><h5><span class="badge badge-secondary">QUEUED</span></h5></td>
                                        <td v-if="g.status == 'under_auction'"><h5><span class="badge badge-warning">UNDER AUCTION</span></h5></td>
                                        <td v-if="g.status == 'withdrawn'"><h5><span class="badge badge-danger">WITHDRAWN</span></h5></td>
                                        <td v-else-if="g.status == 'sold'"><b><span class="badge badge-success">SOLD</span></b>
                                            <span class="badge badge-success" @click="soldModal(g)"><i class="fa fa-check-circle"></i> LOT BUYER</span>
                                        </td>
                                        <td>
                                            <button class="btn btn-primary fa fa-info" @click="details(g.lot_id)"></button>
                                            <button class="btn btn-dark fa fa-cog" @click="alModal(g.id, g.status, g.auction_id)"  v-if="g.status == 'under_auction' || g.status == 'added' || g.status == 'unsold'"></button>
                                            <button class="btn btn-success fa fa-check-circle" @click="sellModal(g)" v-if="g.status == 'under_auction' || g.status == 'unsold'"></button>
                                            <button class="btn btn-warning" v-if="g.status == 'under_auction'" @click="warning(g.id)"><i class="fa fa-warning"></i> 5</button>
                                            <button class="btn btn-secondary fa fa-history" v-if="g.status == 'under_auction' || g.status == 'sold' || g.status == 'withdrawn' || g.status == 'unsold'" @click="history(g.id)"></button>
                                            <button class="btn btn-info fa fa-level-up" @click="autoBidModal(g.id)"></button>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- /.content -->

            <div class="modal" tabindex="-1" role="dialog" id="LotStatusModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Change Lot Status</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <select v-model="auctionLotStatus" placeholder="Select a Status">
                                <option value="added">Added</option>
                                <option value="under_auction">Under Auction</option>
                                <option value="unsold">Unsold</option>
                                <option value="withdrawn">Withdrawn</option>
                            </select>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button class="btn btn-primary" @click="changeAuctionLotStatus">Submit</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal bd-example-modal-lg" tabindex="-1" role="dialog" id="sellLotModal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Sell Lot: {{header}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <table class="table table-striped table-success" id="raveTable">
                                <thead>
                                <tr>
                                    <th scope="col">Control Price</th>
                                    <th scope="col">Bid Price</th>
                                    <th scope="col">Bid Time</th>
                                    <th scope="col">Buyer</th>
                                    <th scope="col">Sell</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(g, index) in lot_bids">
                                    <td>{{control_price}}</td>
                                    <td>{{g.bid_price}}</td>
                                    <td>{{g.bidding_time}}</td>
                                    <td>{{g.buyer}}</td>
                                    <td>
                                        <div class="form-group">
                                            <button class="btn btn-primary fa fa-check-circle form-control" @click="sell(g)"></button>
                                        </div>
                                        <div class="form-group">
                                            <button class="btn btn-danger fa fa-times-circle form-control" @click="withdraw"></button>
                                        </div>
                                        <div class="form-group">
                                            <button class="btn btn-warning fa fa-warning form-control" @click="warning(alId)"></button>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <input type="number" v-model="reset_amount" placeholder="Enter the reset amount" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <button class="btn btn-primary" @click="resetBid"><i class="fas fa-redo"></i> Reset</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <h5><span class="badge badge-secondary">Previous Bids</span></h5>
                                <p v-for="data in show_bids.slice().reverse()" :key="index"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>  <span style="color: #1fa67a">{{data.bid_price}}</span> was raised</p>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="modal bd-example-modal-lg" tabindex="-1" role="dialog" id="soldLotModal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Sold Lot: {{header}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <table class="table table-striped table-success" id="raveTable">
                                <thead>
                                <tr>
                                    <th scope="col">Buyer User ID</th>
                                    <th scope="col">Buyer Name</th>
                                    <th scope="col">Buyer Phone</th>
                                    <th scope="col">Buyer Email</th>
                                    <th scope="col">Sold Price</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{{lot_buyer.id}}</td>
                                    <td>{{lot_buyer.name}}</td>
                                    <td>{{lot_buyer.phone}}</td>
                                    <td>{{lot_buyer.email}}</td>
                                    <td>{{sold_lot_details.highest_bid_price}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="autoBidModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Auto Bids</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">User</th>
                                    <th scope="col">Starting Price</th>
                                    <th scope="col">Upper Quote Price</th>
                                    <th scope="col">Increment</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(g, index) in auto_bids">
                                    <td>{{g.name}}</td>
                                    <td>{{g.starting_quote_price}}</td>
                                    <td>{{g.upper_quote_price}}</td>
                                    <td>{{g.increment}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="history">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Bidding History</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p v-for="(data,index) in bids.slice().reverse()" :key="index"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>  <span style="color: #1fa67a">{{data.bid_price}}</span> was raised by {{data.buyer}}</p>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="addModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Manage Lots</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <v-select v-model="add_lot_id" type="text" label="name" :options="lots" :reduce="lots => lots.id" name="lot_id" placeholder="Select Lot"></v-select>
                            <button class="btn btn-primary fa fa-plus" @click="addLot"> Add Lot</button>
                            <br>
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">Lot Name</th>
                                    <th scope="col">Quote Price</th>
                                    <th scope="col">Control Price</th>
                                    <th scope="col">Manage</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(g, index) in auction_lots">
                                    <th scope="row" >{{g.lot_name}}</th>
                                    <td>{{g.quote_price}}</td>
                                    <td>{{g.control_price}}</td>
                                    <td>
                                        <button class="btn btn-primary fa fa-info" @click="details(g.lot_id)"></button>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isAuctionManager()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log('Manager Dashboard Mounted.');
        console.log('Active Auction: '+ this.$route.params.id);

        window.Echo.channel('auction.newbid')
            .listen('NewBid', (e) => {
                console.log("event recieved");
                if (this.auction_lots.some(el => el.id == e.highest.auction_lot_id)) {
                    var index = this.auction_lots.findIndex((lot => lot.id == e.highest.auction_lot_id));
                    this.auction_lots[index].highest_bid_price = e.highest.bid_price;
                    this.auction_lots[index].buyer_id = e.highest.buyer_id;
                    if (this.alId == e.highest.auction_lot_id) {
                        axios.post("/api/getLotBids", {id: this.alId})
                            .then(response => {
                                this.lot_bids = response.data;

                                this.show_bids.push({bid_price: response.data[0].bid_price});
                                if (this.show_bids.length == 4)
                                    this.show_bids.splice(0, 1);

                                var table = document.getElementById("raveTable");
                                if (table.classList.contains("table-success")) {
                                    table.classList.toggle("table-success");
                                    table.classList.toggle("table-warning");
                                } else {
                                    table.classList.toggle("table-success");
                                    table.classList.toggle("table-warning");
                                }
                            })
                    }
                }
            });

        window.Echo.channel('auction.status-change')
            .listen('StatusChange', (e) => {
                this.getLots();
            });

            window.Echo.channel('auction.fives')
                .listen('Fives', (e) => {
                    console.log("Warning event received");
                });

        },

    created() {
        this.getLots();

    },

    data() {
        return {
            errors: [],
            auction_lots: [],
            lot_id: '',
            auction_id: this.$route.params.id,
            status: '',
            auctionLotStatus: '',
            alId: '',
            lot_bids: [],
            bids: [],
            control_price: '',
            header: '',
            auto_bids: '',
            show_bids: [],
            lots: [],
            add_lot_id: '',
            reset_amount: '',
            lot_buyer: [],
            sold_lot_details: [],
        }
    },

    methods: {
        alModal(id, status, auction) {
            this.alId = id;
            this.auctionLotStatus = status;
            this.auction_id = auction;
            $("#LotStatusModal").modal("show");
        },

        changeAuctionLotStatus() {
            axios.post("/api/auctionLotChange", {
                id: this.alId,
                status: this.auctionLotStatus,
                auction: this.auction_id
            })
                .then(response => {
                    axios.post("/api/getAuctionLots", {id: this.auction_id, auction: true})
                        .then(response => {
                            this.auction_lots = response.data;
                            $("#sellLotModal").modal("hide");
                        })
                })
        },

        withdraw() {
            this.auctionLotStatus = 'withdrawn';
            this.changeAuctionLotStatus();
        },

        unsold() {
            this.auctionLotStatus = 'unsold';
            this.changeAuctionLotStatus();
        },

        sellModal(auction_lot_details) {
            this.alId = null;
            this.auctionLotStatus = null;
            this.control_price = null;
            this.header = null;
            this.alId = auction_lot_details.id;
            this.auctionLotStatus = auction_lot_details.status;
            this.auction_id = auction_lot_details.auction_id;
            this.control_price = auction_lot_details.control_price;
            this.header = auction_lot_details.lot_name;
            axios.post("/api/getLotBids", {id: auction_lot_details.id})
                .then(response => {
                    this.lot_bids = response.data;
                });
            $("#sellLotModal").modal("show");
        },

        soldModal(auction_lot_details) {
            this.alId = null;
            this.auctionLotStatus = null;
            this.auction_id = null;
            this.control_price = null;
            this.lot_buyer = null;
            this.header = null;
            this.auction_id = auction_lot_details.auction_id;
            this.lot_buyer = auction_lot_details.buyer;
            this.header = auction_lot_details.lot_name;
            this.sold_lot_details=auction_lot_details;
            $("#soldLotModal").modal("show");
        },

        resetBid() {
            axios.post("/api/resetBid", {id: this.alId, bid: this.reset_amount})
                .then(response => {
                    toast.fire({
                        type: 'success',
                        title: 'Reset!'
                    });
                    this.getLots();
                })
                .catch(() => {
                    toast.fire({
                        type: 'error',
                        title: 'Failed!'
                    });
                });
        },

        sell(details) {
            var d = new Date();
            var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
            var nd = new Date(utc + (3600000 * +5.5));
            axios.post("/api/auctionLotChange", {
                id: this.alId,
                status: "sold",
                auction: this.auction_id,
                bid: details.id
            })
                .then(response => {
                    toast.fire({
                        type: 'success',
                        title: 'Sold!'
                    });
                    $("#sellLotModal").modal("hide");
                    console.log('Lot Sold: '+ this.alId + ' in auction: '+ this.auction_id);
                    this.getLots();
                });
        },

        getLots() {
            axios.post("/api/getAuctionLots", {id: this.auction_id, auction: true})
                .then(response => {
                    this.auction_lots = response.data;
                });
        },

        getAvailableLots() {
            axios.post("/api/getAvailableLots")
                .then(response => {
                    this.lots = response.data.data.data;
                })
        },

        addDialog() {
            this.getAvailableLots();
            $("#addModal").modal("show");
        },

        addLot() {
            axios.post("/api/addAuctionLot", {
                auction_id: this.auction_id,
                lot_id: this.add_lot_id,
                created_by: this.$userId,
                updated_by: this.$userId
            })
                .then(() => {
                    this.getAvailableLots();
                    this.getLots();
                });
        },

        details(id) {
            window.open('/home/auction-manager/lot-details/' + id)
        },

        warning(id) {
            axios.post("/api/fiveSecondRule", {id: id})
                .then(response => {
                    toast.fire({
                        type: 'success',
                        title: 'Countdown Begun!'
                    });
                })
        },

        history(id) {
            axios.post("/api/showBids", {id: id})
                .then(response => {
                    this.bids = response.data;
                    $('#history').modal('show');
                })
        },

        autoBidModal(id) {
            axios.post('/api/getAutoBids', {id: id})
                .then(response => {
                    this.auto_bids = response.data;
                    $("#autoBidModal").modal('show');
                })
        }
    }
}
</script>

<style>
.t-header {
    position: sticky;
    top: 0;
}

/*.blink{
  background-color: #20c997;
}
.blink-span{
  color: white;
  animation: blink 1s linear infinite;
}
@keyframes blink{
0%{opacity: 0;}
50%{opacity: .5;}
100%{opacity: 1;}
}*/
</style>
